/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type useFeedbackChannelsQueryVariables = {
    tenantId: string;
};
export type useFeedbackChannelsQueryResponse = {
    readonly feedbackChannels: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly title: string;
                readonly description: string | null;
            } | null;
        } | null> | null;
    } | null;
};
export type useFeedbackChannelsQuery = {
    readonly response: useFeedbackChannelsQueryResponse;
    readonly variables: useFeedbackChannelsQueryVariables;
};



/*
query useFeedbackChannelsQuery(
  $tenantId: ID!
) {
  feedbackChannels(tenantId: $tenantId) {
    edges {
      node {
        id
        title
        description
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "concreteType": "FeedbackChannelConnection",
            "kind": "LinkedField",
            "name": "feedbackChannels",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackChannelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeedbackChannel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useFeedbackChannelsQuery",
            "selections": (v1 /*: any*/),
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useFeedbackChannelsQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "6b03e1ddda44dad06623625751644a30",
            "id": null,
            "metadata": {},
            "name": "useFeedbackChannelsQuery",
            "operationKind": "query",
            "text": "query useFeedbackChannelsQuery(\n  $tenantId: ID!\n) {\n  feedbackChannels(tenantId: $tenantId) {\n    edges {\n      node {\n        id\n        title\n        description\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b5bcd7d4ac90042464c96f1c5da9fbfa';
export default node;
